export const API_URL = process.env.REACT_APP_API_URL;
export const SERVICES_API_URL = process.env.REACT_APP_SERVICES_API_URL;
export const AUTHENTIC_API_URL = `${SERVICES_API_URL}/authentic/v0`;
export const AUTHENTIC_CLIENT_ID = process.env.REACT_APP_AUTHENTIC_CLIENT_ID;
